// „Übersicht" / Startseite (frontend/src/pages/Overview.tsx) — deutsche QUELLE.
//
// `vorMinuten`/`vorStunden`/`vorTagen` sind WORTE, kein Zahlformat: der Fall
// „älter als eine Woche" fällt in Overview.tsx weiter auf
// `toLocaleDateString("de-DE", …)` zurück und bleibt damit in jeder
// Oberflächensprache deutsch datiert (docs/i18n.md §2).
export const overview = {
  gutenMorgen: "Guten Morgen",
  hallo: "Hallo",
  gutenAbend: "Guten Abend",
  bald: "(bald)",
  faelligDieseWoche: (n: number) =>
    `${n} ${n === 1 ? "Aufgabe" : "Aufgaben"} diese Woche fällig`,
  zuletzt: "Zuletzt",
  alleChats: "Alle Chats",
  gerade: "gerade",
  vorMinuten: (n: number) => `vor ${n} min`,
  vorStunden: (n: number) => `vor ${n} h`,
  vorTagen: (n: number) => `vor ${n} T`,
};

export type OverviewKatalog = typeof overview;
